import { useState, useEffect } from "react";
import { AdaptedButton } from "../../components/adaptedButton";
import { View, StyleSheet, ScrollView, Text, KeyboardAvoidingView } from "react-native";
import { Slider } from '@miblanchard/react-native-slider';

export function Page3({ handleClick }) {
    const [selectedValue, setSelectedValue] = useState(0);
    const [ageValue, setAgeValue] = useState('Under 18')
    const increments = [
        'Under 18',
        '18-24',
        '25-29',
        '30-34',
        '35-39',
        '40-44',
        '45-49',
        '50-54',
        '55-59',
        '60-64',
        '65-69',
        '70-74',
        '75-79',
        'Over 80',
    ];

    
    const ticks = [
        '>18',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '80+'
    ];


    useEffect(() => {
        handleClick('age', ageValue);
        console.log(ageValue)
    }, [ageValue]);

    const handleSliderValueChange = (value) => {
        setSelectedValue(value)
        setAgeValue(increments[value])
        //setSelectedValue(value)
        // console.log(value)
        // handleClick('age', increments[value]);
    };


    const renderTrackMarkComponent = (index) => {
        return (
            <View style={styles.fix}>
                <View style={styles.bottomTick}>
                <Text style={styles.tickText}>
            {ticks[index]}
            </Text>
                </View>
                <View style={styles.tickLine}>
                </View>
            </View>
        )
    }

    // const renderTrackMarkComponent = (index) => {
    //     const tickStyle = index % 2 === 0 ? styles.bottomTick : styles.topTick;
    //     return (
    //       <View style={tickStyle}>
    //         <Text>
    //         {increments[index]}
    //         </Text>
    //       </View>
    //     );
    //   };

    return (
        <View>
            <View style={styles.ageDisplay}>
                <Text style={styles.ageText}>{increments[selectedValue]}</Text>
            </View>
            <View style={styles.sliderDisplay} >
                <View style={styles.slider}>
                    <Slider
                        value={selectedValue}
                        minimumValue={0}
                        maximumValue={increments.length-1}
                        step={1}
                        onValueChange={handleSliderValueChange}
                        thumbTintColor={'#3B1C15'}
                        minimumTrackTintColor={'#3B1C15'}
                        //maximumTrackTintColor={'#3B1C15'}
                        thumbTouchSize={{ width: 40, height: 40 }}
                        thumbStyle={styles.thumbStyle}
                        trackStyle={styles.trackStyle}
                        animateTransitions={true}
                        animationType={'timing'}
                        trackMarks={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]}
                        renderTrackMarkComponent={renderTrackMarkComponent}
                    />
                </View>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    buttonRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%'
    },
    tickText: {
        color: '#3B1C15',
        fontSize: 20,
        maxWidth: '100%',
        textAlign: 'center',
        fontFamily: 'DM Sans',
    },
    ageDisplay: {
        justifyContent: 'center',
        width: '100%',
        marginTop: -30
    },
    sliderDisplay: {
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
        marginTop: 90
    },
    seperator: {
        marginTop: 70,
        border: '3px solid red',
        width: "100%"
    },
    topTick: {
        marginTop: 40,
        justifyContent: 'center',
    },
    bottomTick: {
        marginTop: -40,
        justifyContent: 'center',
    },
    tickLine:{
        height: 18,
        width: 2,
        border: '2px solid #3B1C15',
        marginTop:17,
        marginLeft:9.3
    },
    fix: {
        width: '100%',
        justifyContent: 'center'
    },
    slider: {
        width: '90%',
        justifyContent: 'center',
    },
    ageText: {
        color: '#3B1C15',
        fontSize: 25,
        maxWidth: '100%',
        textAlign: 'center',
        fontFamily: 'DM Sans',
    }
});

       // <View>
        //     <View style={styles.buttonRow}>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'Under 18'}
        //                 selected={selectedValue === 'Under 18'}
        //             />
        //         </View>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'18-24'}
        //                 selected={selectedValue === '18-24'}
        //             />
        //         </View>
        //     </View>
        //     <View style={styles.buttonRow}>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'25-29'}
        //                 selected={selectedValue === '25-29'}
        //             />
        //         </View>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'30-34'}
        //                 selected={selectedValue === '30-34'}
        //             />
        //         </View>
        //     </View>
        //     <View style={styles.buttonRow}>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'35-39'}
        //                 selected={selectedValue === '35-39'}
        //             />
        //         </View>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'40-44'}
        //                 selected={selectedValue === '40-44'}
        //             />
        //         </View>
        //     </View>
        //     <View style={styles.buttonRow}>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'45-49'}
        //                 selected={selectedValue === '45-49'}
        //             />
        //         </View>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'50-54'}
        //                 selected={selectedValue === '50-54'}
        //             />
        //         </View>
        //     </View>
        //     <View style={styles.buttonRow}>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'55-59'}
        //                 selected={selectedValue === '55-59'}
        //             />
        //         </View>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'60-64'}
        //                 selected={selectedValue === '60-64'}
        //             />
        //         </View>
        //     </View>
        //     <View style={styles.buttonRow}>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'65-69'}
        //                 selected={selectedValue === '65-69'}
        //             />
        //         </View>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'70-74'}
        //                 selected={selectedValue === '70-74'}
        //             />
        //         </View>
        //     </View>
        //     <View style={styles.buttonRow}>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'75-79'}
        //                 selected={selectedValue === '75-79'}
        //             />
        //         </View>
        //         <View style={styles.fix}>
        //             <AdaptedButton
        //                 handleClick={handleButtonClick}
        //                 field={'age'}
        //                 fieldValue={'80+'}
        //                 selected={selectedValue === '80+'}
        //             />
        //         </View>
        //     </View>

        // </View>